"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../core/collapse"));
var _button = _interopRequireDefault(require("../../core/button"));
var _modal = _interopRequireDefault(require("../../core/modal"));
var _submit = _interopRequireDefault(require("../../core/submit"));
var _row = _interopRequireDefault(require("../../core/row"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _input = _interopRequireDefault(require("../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newEntryType: {
    id: null,
    description: null,
    priority: null,
    overrideBibAdjuster: null,
    siwiCode: null,
    canPreRegister: false,
    openForOnlineEntryLeadTimeOverride: null,
    closedForOnlineEntryLeadTimeOverride: null,
    lateFeesLeadTimeOverride: null
  },
  isOpened: false,
  isSubmitting: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "ID");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Description");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Priority");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Override Bib Adjuster");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Siwi Code");
var _ref6 = /*#__PURE__*/_react.default.createElement("h5", null, "Override Lead Times in Days");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Open for Entry");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entries Close");
var _ref9 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Late Fees Due");
var _ref10 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Can Pre-Register");
class AddEntryType extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onCancelNewEntryType", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newEntryType: {
          ...this.state.newEntryType,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.setState({
        isSubmitting: true
      });
      this.props.addEntryType(this.state.newEntryType).then(result => {
        if (result && result.error) {
          this.setState({
            errorMessage: result.error,
            isSubmitting: false
          });
        } else {
          this.setState(initialState);
        }
      });
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        errorMessage: null
      });
    });
  }
  render() {
    const dismissErrorButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onErrorDismissed
    }, "OK");
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Entry Type' : 'Add Entry Type'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, !this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: dismissErrorButton,
      onClose: this.props.onErrorDismissed
    }, this.state.errorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-6"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "id",
      value: this.state.newEntryType.id,
      onChange: this._setValue.bind(this, 'id'),
      maxLength: 4,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "description",
      value: this.state.newEntryType.description,
      onChange: this._setValue.bind(this, 'description'),
      maxLength: 35,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "priority",
      type: "Integer",
      value: this.state.newEntryType.priority,
      onChange: this._setValue.bind(this, 'priority'),
      maxLength: 4
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "overrideBibAdjuster",
      type: "Integer",
      value: this.state.newEntryType.overrideBibAdjuster,
      onChange: this._setValue.bind(this, 'overrideBibAdjuster'),
      maxLength: 5
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "siwiCode",
      value: this.state.newEntryType.siwiCode,
      onChange: this._setValue.bind(this, 'siwiCode'),
      maxLength: 10
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-6"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, _ref6, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "openForOnlineEntryLeadTimeOverride",
      type: "Integer",
      value: this.state.newEntryType.openForOnlineEntryLeadTimeOverride,
      onChange: this._setValue.bind(this, 'openForOnlineEntryLeadTimeOverride'),
      maxLength: 3
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "closedForOnlineEntryLeadTimeOverride",
      type: "Integer",
      value: this.state.newEntryType.closedForOnlineEntryLeadTimeOverride,
      onChange: this._setValue.bind(this, 'closedForOnlineEntryLeadTimeOverride'),
      maxLength: 3
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref9, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "closedForOnlineEntryLeadTimeOverride",
      type: "Integer",
      value: this.state.newEntryType.lateFeesLeadTimeOverride,
      onChange: this._setValue.bind(this, 'closedForOnlineEntryLeadTimeOverride'),
      maxLength: 3
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref10, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "canPreRegister",
      checked: this.state.newEntryType.canPreRegister,
      onChange: this._setValue.bind(this, 'canPreRegister')
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-12"
    }, /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Add Entry Type"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancelNewEntryType
    }, "Cancel")))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(AddEntryType, undefined, (client, props) => ({
  addEntryType(newEntryType) {
    return client.update('EntryType.create', newEntryType);
  }
}));